import { create } from 'zustand';

interface InviteModalState {
  isOpen: boolean;
  open:   () => void;
  close:  () => void;
}

export const useInviteModalStore = create<InviteModalState>((set) => ({
  isOpen: false,
  open:   () => set({ isOpen: true }),
  close:  () => set({ isOpen: false }),
}));
